import { createStore } from 'vuex'
import App from './modules/app'
import Auth from './modules/auth'
import Cart from './modules/cart'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
import SecureLS from 'secure-ls'
const ls = new SecureLS({ isCompression: false })

let cookieStorage = {
  getItem: function(key) {
    return Cookies.getJSON(key)
  },
  setItem: function(key, value) {
    return Cookies.set(key, value, { expires: 3, secure: false })
  },
  removeItem: function(key) {
    return Cookies.remove(key)
  }
}
let secureStorage = {
  getItem: function(key) {
    return ls.get(key)
  },
  setItem: function(key, value) {
    return ls.set(key, value)
  },
  removeItem: function(key) {
    return ls.remove(key)
  }
}

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app: App,
    auth: Auth,
    cart: Cart
  },
  plugins: [
    createPersistedState({
      key: 'Lion-App-Store',
      paths: ['cart.items', 'cart.checkoutStatus'],
      storage: secureStorage,
      getState: secureStorage.getItem,
      setState: secureStorage.setItem
    })
  ]
})
